import CommonFields, { CommonFieldsProps } from "./CommonFields";
import { CommonLabel } from "./components";

export default CommonFields;
export { CommonLabel };
export type { CommonFieldsProps };
